import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {Wrapper} from '../hooks/common';
import {Home, Scan} from '../hooks/home';

export default [
  <Route path="/scan" component={props => <Wrapper component={Scan} {...props} />} exact key="scan" />,
  <Route path="/" component={props => <Wrapper component={Home} {...props} />} exact key="home" />,
  <Route component={() => <Redirect to='/' />} exact key="default" />
];